<template>
  <div class="">
    <form @submit.prevent="onSubmit">
      <form-group class="col text-right mb-3" :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }">
          <label>نام اشتراک</label>

          <input v-model="form.name" type="text" class="form-control">

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
      <form-group class="col text-right mb-3" :validations="$v.form.value">
        <div slot-scope="{ errors, invalid }">
          <label>اعتبار</label>

          <input v-model="form.value" type="text" class="form-control">

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="col text-right mb-3" :validations="$v.form.price">
        <div slot-scope="{ errors, invalid }">
          <label>قیمت</label>

          <input v-model="form.price" type="text" class="form-control">
          {{ formatNumber(form.price) }}

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="col text-right mb-3" :validations="$v.form.offer">
        <div slot-scope="{ errors, invalid }">
          <label>تخفیف</label>

          <input v-model="form.offer" type="text" class="form-control">
          {{ formatNumber(form.offer) }}

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary col-5 rounded-pill">ثبت</button>
      </div>

    </form>
  </div>
</template>


<script>

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import {required, integer} from "vuelidate/lib/validators";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ManageSubscriptionItem",
  components: {FormErrorsManager, FormGroup},
  props: {
    subscription: {
      default: null
    },
    item: {
      default: null
    }
  },
  data() {
    return {
      form: {
        name: '',
        value: '',
        offer: null,
        price: null,
      }
    }
  },
  computed: {
    inUpdateMode() {
      return this.item != null
    }
  },
  validations: {
    form: {
      name: {required},
      value: {required, integer},
      offer: {required, integer},
      price: {required, integer},
    },
  },
  methods: {
    formatNumber,
    createSubscriptionItem() {
      this.form.subscription_id = this.subscription.id
      let req = this.$store.dispatch('Subscription/creatSubscriptionItem', this.form)

      req.then(res => {
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        this.$emit('loadItems', true)
      })

    },
    async updateSubscriptionItem() {
      this.form.subscription_id = this.subscription.id
      let req = this.$store.dispatch('Subscription/updateSubscriptionItem', this.form)

      req.then(res => {
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        this.$emit('loadItems', true)
      })
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {

      if (!this.invalid()) {
        return false
      }

      if (this.inUpdateMode) {
        this.updateSubscriptionItem()
      } else {
        this.createSubscriptionItem()
      }

    },

  },
  mounted() {
    if (this.item != null) {
      this.form = this.item
    }
  },
}


</script>


<style scoped>

</style>